module.exports = __webpack_public_path__ + "static/media/tab_customer.7635dbb6.png";